export enum SmartSearchType {
  NEW_PROPERTY_MAXIMUM_PRICE = 'NEW_PROPERTY_MAXIMUM_PRICE',
  MORTGAGE_BORROW_MORE = 'MORTGAGE_BORROW_MORE',
  MORTGAGE_PAY_FASTER = 'MORTGAGE_PAY_FASTER',
  SPEAK_TO_AN_EXPERT = 'SPEAK_TO_AN_EXPERT',
}
